export { Prompt as default } from 'react-router';


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-router-dom/es/Prompt.js
// module id = 1190
// module chunks = 0